import React from "react";
import { MenuList as ChakraMenuList } from "@chakra-ui/react";
export function FilterMenuList(props) {
    return (React.createElement(ChakraMenuList, { motionProps: {
            initial: {
                scale: 0.9,
                opacity: 0,
            },
            variants: {
                enter: {
                    scale: 1,
                    opacity: 1,
                    transition: {
                        type: "spring",
                        damping: 24,
                        stiffness: 600,
                    },
                },
                exit: {
                    scale: 0.9,
                    opacity: 0,
                    transition: {
                        type: "spring",
                        duration: 0.15,
                    },
                },
            },
        }, ...props }));
}
